import { initialErrors } from "../Constants/Purchased-history.constants";
import { Types } from "../Constants/Types";
import OrderType from "../Interfaces/purchased-history-interface";

const ScrapingOrdersReducer = (state: OrderType['status'] = {
        order: undefined,
        orders: [],
        orderStatus: [],
        poStatuses: [],
        orderBrandsNotShipped: [],
        printOrders: [],
        lprint: false,
        lexport: false,
        lorders: false,
        lorder: false,
        loadStatus: false,
        loadPoStatuses: false,
        poStatusesFetched: false,
        loadBrands: false,
        pages: 0,
        badge: 0,
        total: 0,
        error: initialErrors
    },
    action: OrderType['action']
    ) => {

    switch (action.type) {

        case Types.PH_SEARCH_ORDERS:
            return {...state, results: action.payload, resultPages: action.pages, total: action.total};

        case Types.PH_FETCH_ORDERS:
            return {...state, orders: action.payload, pages: action.pages, total: action.total};

        case Types.PH_FETCH_ORDER_STATUS:
            return {...state, orderStatus: action.payload};

        case Types.PH_FETCH_PO_STATUSES:
            return {...state, poStatuses: action.payload, poStatusesFetched: true};

        case Types.PH_FETCH_ORDER_BRANDS_NOT_SHIPPED:
            return {...state, orderBrandsNotShipped: action.payload};

        case Types.PH_FETCH_PRINT_ORDERS:
            return {...state, printOrders: action.payload};

        case Types.PH_FETCH_ORDER:
            return {...state, order: action.payload};

        case Types.PH_CREATE_ORDER:
            // Limit stored orders to prevent memory leaks (keep latest 50)
            const updatedOrders = [action.payload, ...state.orders];
            if (updatedOrders.length > 500) {
                updatedOrders.length = 500;
            }
            return {...state, orders: updatedOrders};

        case Types.PH_UPDATE_ORDER: 
            return {...state, orders: state.orders.map(order => order._id === action.payload.id ? action.payload : order)};
        
        case Types.PH_STATE_ORDER: 
            return {...state, orders: state.orders.map(order => order._id === action.payload.id ? {...order, ...action.payload} : order), order: {...state.order, state: action.payload.state, subState: action.payload.state}};

        case Types.PH_STATE_ORDERS:
            return {...state, orders: state.orders.map(order => action.payload.ids.includes(order._id) ? {...order, poState: action.payload.state} : order)};

        case Types.PH_STATE_PO:
            return {...state, orders: state.orders.map(order => order._id === action.payload.id ? {...order, poState: action.payload.state} : order), order: {...state.order, poState: action.payload.state}};

        case Types.PH_DELETE_ORDER: 
            return {...state, orders: state.orders.filter(order => order._id !== action.payload)}

        case Types.PH_START_ORDERS:
            return {...state, lorders: true};

        case Types.PH_END_ORDERS:
            return {...state, lorders: false};

        case Types.PH_START_ORDER:
            return {...state, lorder: true};

        case Types.PH_END_ORDER:
            return {...state, lorder: false};

        case Types.PH_START_ORDER_STATUS:
            return {...state, loadStatus: true};

        case Types.PH_END_ORDER_STATUS:
            return {...state, loadStatus: false};

        case Types.PH_START_PO_STATUSES:
            return {...state, loadPoStatuses: true};

        case Types.PH_END_PO_STATUSES:
            return {...state, loadPoStatuses: false};

        case Types.PH_START_ORDER_BRANDS_NOT_SHIPPED:
            return {...state, loadBrands: true};

        case Types.PH_END_ORDER_BRANDS_NOT_SHIPPED:
            return {...state, loadBrands: false};

        case Types.PH_START_PRINT_ORDERS:
            return {...state, lprint: true, printOrders: []};

        case Types.PH_END_PRINT_ORDERS:
            return {...state, lprint: false};

        case Types.PH_START_EXPORT_ORDERS:
            return {...state, lexport: true};

        case Types.PH_END_EXPORT_ORDERS:
            return {...state, lexport: false};

        case Types.PH_ERROR_ORDER:
            return {...state, error: action?.payload ? {...state.error, [action?.field!]: action.payload} : {...state.error, [action?.field!]: null}};

        case Types.PH_RESET_ORDER:
            return {...state, error: initialErrors}

        case Types.PH_ORDERS: 
            return {...state, badge: action.payload};

        default: 
            return state
    }
}

export default ScrapingOrdersReducer;